import React from "react";
import { Col } from "react-grid-system";

export const PaddingLeftCol = (props) => (
  <Col 
    {...props} 
    style={{
      ...(props.style || {}),
      paddingLeft: "30px",
      paddingRight: "0",
    }} 
  />
);

export const NoPaddingCol = (props) => (
  <Col 
    {...props} 
    style={{
      ...(props.style || {}),
      paddingLeft: "0",
      paddingRight: "0",
    }} 
  />
);